module.exports = {
      id: "ic-calendar-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-calendar-usage",
      toString: function () {
        return this.url;
      }
    }